/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */
export var SelectionStyle = /*#__PURE__*/function (SelectionStyle) {
  SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
  SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
  SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
  SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
  return SelectionStyle;
}({});